const SpinnerLoading = () => {
  return <div className="flex justify-center mt-4">
    <div className="w-8 h-8 border-4 border-blue-700 border-solid rounded-full animate-spin border-t-transparent" />
  </div>
}

export default SpinnerLoading